import { Injectable } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

export interface ToastInfo {
  header: string;
  body: string;
  type: 'success' | 'danger' | 'info';
  delay?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  toasts: ToastInfo[] = [];

  show(header: string, body: string, type: 'success' | 'danger' | 'info' = 'info', delay: number = 5000) {
    this.toasts.push({ header, body, type, delay });
  }

  remove(toast: ToastInfo) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
